import React from 'react';
import ToggleThemeBtn from './shared/ToggleThemeBtn';
import User from './shared/User';

const HomepageHeaderButtons = () => {
  return (
    <div className="header_right header-buttons">
      <ToggleThemeBtn />
      <div className="md-screen-buttons tab_list">
        <div className="homepage-user-btn tab_items tab_items_user">
          <User />
        </div>
        <div className="kapa-open ask-ai-btn">
          <div style={{ display: 'block', width: '1rem', height: '1.25rem' }}>
            <svg>
              <use
                href="/assets/images/icons/fa-sparkles.svg"
                fill="currentColor"
              ></use>
            </svg>
          </div>
          <span>Ask AI</span>
        </div>
        <div className="search-btn" data-search-btn="false">
          <div style={{ display: 'block', width: '1rem', height: '1.25rem' }}>
            <svg>
              <use
                href="/assets/images/icons/fa-search.svg"
                fill="currentColor"
              ></use>
            </svg>
          </div>
          <div className="dsc-search">
            <div id="homepage-search"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomepageHeaderButtons;
